/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Cap_Apps_AuthorInputs */



/**
* | output |
* | --- |
* | "Author apps & dashboards" |
*
* @param {Rights_Cap_Apps_AuthorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_cap_apps_author = /** @type {((inputs?: Rights_Cap_Apps_AuthorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Cap_Apps_AuthorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Apps & Dashboards erstellen")
	return /** @type {LocalizedString} */ ("Author apps & dashboards")
});